import { MPCA } from '../../domain/mpca';
import { Zone } from '../../domain/zone';
import { mapper } from '../../tools/mapping/mapper';
import { MPCAEntity } from '../entity';
import type { AppDB } from '../db';

export class MpcaRepository {
    constructor(private readonly database: AppDB) {}


    async clearMPCAById(ids: number[]) {
        await this.database.mpcas.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.mpcas.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }

    async getMPCAEntityById(id: number) {
        return await this.database.mpcas.where('Id').equals(id).first(async mpca => {
            return mpca;
        });
    }

    async addMPCAToZone(zone: Zone, isDepose: boolean, mpca: MPCA) {

        const ze = await this.database.zones.where('Code').equals(zone.Code).and(x => { return x.IsDepose === isDepose }).first();
        if (!ze || !ze.Id) {
            return;
        }
        await this.database.attachMPCAToZone(mpca, ze.Id);
        return true;
    }

    async attachMPCAToZone(mpca: MPCA, zoneId: number) {
        let mpcaId: number;
        const mpcae = mapper.map(mpca, MPCA, MPCAEntity);

        const ze = await this.database.getZoneEntityById(zoneId);
        mpcaId = await this.database.mpcas.add(mpcae);
        await this.database.zones.update(zoneId, {
            MPCAIds: ze?.MPCAIds ? [...ze.MPCAIds, mpcaId] : [mpcaId]
        });
        return mpcaId;
    }

    async attachMPCAToProcess(mpca: MPCA, processTechniqueId: number) {
        let mpcaId: number;
        const mpcae = mapper.map(mpca, MPCA, MPCAEntity);

        mpcaId = await this.database.mpcas.add(mpcae);
        await this.database.processTechniques.update(processTechniqueId, {
            MPCAId: mpcaId
        });
        return mpcaId;
    }
}
